import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { ErrorResponse } from "../../../../../requests/@types";
import api from "../../../../../services/api";
import { getRlcsPrepareReanalyzeData } from "../../../queryKeys";

interface RlcsPrepareReanalyzeDataProps {
  hash: string;
  isEnabled: boolean;
}

interface Status {
  enabled: boolean;
  autoupload?: boolean;
  additional_information: string;
}

interface Response {
  rl_dynamic_analysis: Status;
  rl_dynamic_analysis_interactive: Status;
}

const useRlcsPrepareReanalyzeData = ({
  hash,
  isEnabled = true
}: RlcsPrepareReanalyzeDataProps) => {
  const { data, isLoading } = useQuery<
    AxiosResponse<Response>,
    ErrorResponse,
    Response
  >({
    queryKey: getRlcsPrepareReanalyzeData(hash),
    queryFn: () => api.prepareRlcsReanalyze({ hashValue: hash }),
    select: ({ data: response }) => response,
    enabled: isEnabled
  });

  return {
    data,
    isLoading
  };
};

export default useRlcsPrepareReanalyzeData;
